import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { ECellColor } from './calendarTypes'

interface ColorExplonationBoxProps {
  title: string
  color: ECellColor
}

const ColorExplonationBox: React.FC<ColorExplonationBoxProps> = ({
  title,
  color,
}) => (
  <Grid item xs={6} display="flex" justifyContent="center">
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // width: "1",
        height: '3rem',
        transition: 'all 50ms ease-in-out',
        border: '0.5px solid #D9DCE0',
        color: '#FFFFFF',
        background: color,
        width: '120px',
        borderRadius: '10px',
        borderWidth: '1px',
        marginBottom: '10px',
        padding: '5px',
      }}
    >
      <Typography fontWeight="bold" variant="caption">
        {title}
      </Typography>
    </div>
  </Grid>
)

export default ColorExplonationBox
